import { render } from "./PortalHelp.vue?vue&type=template&id=71cd9203"
import script from "./PortalHelp.vue?vue&type=script&lang=js"
export * from "./PortalHelp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__